/* eslint eqeqeq: 0 */
import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import classNames from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import GroupAddIcon from '@material-ui/icons/GroupAdd'
// import Help from '@material-ui/icons/Help'
// import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import GroupIcon from '@material-ui/icons/Group'
import Tooltip from '@material-ui/core/Tooltip'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Fade from '@material-ui/core/Fade'
import Divider from '@material-ui/core/Divider'
import ListSubheader from '@material-ui/core/ListSubheader'
import Checkbox from '@material-ui/core/Checkbox'
import ListItemText from '@material-ui/core/ListItemText'
import CircularProgress from '@material-ui/core/CircularProgress'
// import SvgIcon from '@material-ui/core/SvgIcon'
import { pick, isEqual, capitalize } from 'lodash'
import { push } from 'connected-react-router'
import { userSignOut } from '../actions/auth'
import { toggleDrawer, closeDrawer, openProfileDialog } from '../actions/view'
import { deselectAllContacts } from '../actions/contacts/addOrEdit'
// import SmartRouter from './SmartRouter.js'
// import header_logo from '../header_logo.png'
// import logomark from '../logo-mark.png'
// import logosvg from '../logo.svg'
import { ReactComponent as LogoMark } from '../Logo_Mark.svg'
// import Hidden from '@material-ui/core/Hidden'
import language from 'utils/vast-languagepack'
import {
  addContactsToGroup,
  removeContactsFromGroup,
  selectAllContacts,
} from '../actions/contacts/groups'
import ActionType from '../actions/ActionType'
import Button from 'components/theme/Button'
import { withRouter } from 'react-router-dom'
// import { Person } from '@material-ui/icons'
import HeaderAddButton from './HeaderAddButton'
import HeaderVastGptButton from './HeaderVastGptButton'
import * as routes from './routes'
import HelpTooltip from 'components/theme/HelpTooltip'

const mapStateToProps = (state, { location }) => {
  const currentRoute = Object.values(routes).find(route =>
    location.pathname.startsWith(route.path),
  )

  let title = ''
  let displayName = ''

  if (
    !location.pathname ||
    location.pathname === '/' ||
    location.pathname.startsWith('/inbox')
  ) {
    title = 'Chat'
  } else if (currentRoute) {
    title = currentRoute.title || capitalize(`${currentRoute.endpoint}s`)
    const pathParts = location.pathname.split('/')
    if (
      pathParts.length > 2 &&
      pathParts[pathParts.length - 1] !== '' &&
      pathParts[pathParts.length - 1] !== 'new'
    ) {
      const entityId = pathParts[pathParts.length - 1]
      if (currentRoute.displayName) {
        displayName = currentRoute.displayName(state, entityId)
      } else {
        displayName = state.data?.[currentRoute.endpoint]?.[entityId]?.name
      }
    }
  }

  return {
    title,
    displayName,
    drawerOpen: state.view.drawerOpen,
    currentUser: state.auth.currentUser,
    selectedContacts: state.contacts.selectedContacts,
    groups: state.contacts.groupsByID,
    company_logo_url_color:
      state.data?.['account/preference']?.preferences?.company_logo_url_color,
    business_name: state.data?.account?.business_name,
    currentRoute,
  }
}

const mapDispatchToProps = dispatch => {
  const { Contacts } = ActionType
  const dispatchType = actionType => dispatch => dispatch({ type: actionType })
  // const dispatchPush = path => dispatch => dispatch(push(path))

  return bindActionCreators(
    {
      userSignOut,
      toggleDrawer,
      closeDrawer,
      deselectAllContacts,
      addContactsToGroup,
      removeContactsFromGroup,
      openCreateGroupFromSelectedDialog: () =>
        dispatchType(Contacts.OPEN_CREATE_GROUP_FROM_SELECTED_DIALOG),
      push,
      selectAllContacts,
      openProfileDialog,
    },
    dispatch,
  )
}

const styles = theme => ({
  search: {
    position: 'relative',

    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    marginRight: 2,
    marginLeft: 0,
    width: '200%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 3,
      width: 'auto',
    },
  },
  searchIcon: {
    width: 10,
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: 7,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: 200,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 20,
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main,
  },
  colorOnContactSelection: {
    backgroundColor: '#fff',
  },
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  icon: {},
  logo: {
    [theme.breakpoints.down('xs')]: {
      height: '41px',
      marginTop: '5px',
    },
    [theme.breakpoints.up('sm')]: {
      height: '49px',
      marginTop: '5px',
    },
  },
  grow: {
    flexGrow: 1,
    // fontSize: '2.25rem',
  },
  titleContainer: {
    flexGrow: 1,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginRight: theme.spacing.unit,
  },
  helpTooltipContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  actionButtons: {
    display: 'flex',
    alignItems: 'center',
  },
})

const urlParams = new URLSearchParams(window.location.search)
const jwtToken = urlParams.get('jwtToken')

// function VastMenuIcon(props) {
//   return (
//     <SvgIcon {...props}>
//       <path d="M666.3 296.5c0-32.5-40.7-63.3-103.1-82.4 14.4-63.6 8-114.2-20.2-130.4-6.5-3.8-14.1-5.6-22.4-5.6v22.3c4.6 0 8.3.9 11.4 2.6 13.6 7.8 19.5 37.5 14.9 75.7-1.1 9.4-2.9 19.3-5.1 29.4-19.6-4.8-41-8.5-63.5-10.9-13.5-18.5-27.5-35.3-41.6-50 32.6-30.3 63.2-46.9 84-46.9V78c-27.5 0-63.5 19.6-99.9 53.6-36.4-33.8-72.4-53.2-99.9-53.2v22.3c20.7 0 51.4 16.5 84 46.6-14 14.7-28 31.4-41.3 49.9-22.6 2.4-44 6.1-63.6 11-2.3-10-4-19.7-5.2-29-4.7-38.2 1.1-67.9 14.6-75.8 3-1.8 6.9-2.6 11.5-2.6V78.5c-8.4 0-16 1.8-22.6 5.6-28.1 16.2-34.4 66.7-19.9 130.1-62.2 19.2-102.7 49.9-102.7 82.3 0 32.5 40.7 63.3 103.1 82.4-14.4 63.6-8 114.2 20.2 130.4 6.5 3.8 14.1 5.6 22.5 5.6 27.5 0 63.5-19.6 99.9-53.6 36.4 33.8 72.4 53.2 99.9 53.2 8.4 0 16-1.8 22.6-5.6 28.1-16.2 34.4-66.7 19.9-130.1 62-19.1 102.5-49.9 102.5-82.3zm-130.2-66.7c-3.7 12.9-8.3 26.2-13.5 39.5-4.1-8-8.4-16-13.1-24-4.6-8-9.5-15.8-14.4-23.4 14.2 2.1 27.9 4.7 41 7.9zm-45.8 106.5c-7.8 13.5-15.8 26.3-24.1 38.2-14.9 1.3-30 2-45.2 2-15.1 0-30.2-.7-45-1.9-8.3-11.9-16.4-24.6-24.2-38-7.6-13.1-14.5-26.4-20.8-39.8 6.2-13.4 13.2-26.8 20.7-39.9 7.8-13.5 15.8-26.3 24.1-38.2 14.9-1.3 30-2 45.2-2 15.1 0 30.2.7 45 1.9 8.3 11.9 16.4 24.6 24.2 38 7.6 13.1 14.5 26.4 20.8 39.8-6.3 13.4-13.2 26.8-20.7 39.9zm32.3-13c5.4 13.4 10 26.8 13.8 39.8-13.1 3.2-26.9 5.9-41.2 8 4.9-7.7 9.8-15.6 14.4-23.7 4.6-8 8.9-16.1 13-24.1zM421.2 430c-9.3-9.6-18.6-20.3-27.8-32 9 .4 18.2.7 27.5.7 9.4 0 18.7-.2 27.8-.7-9 11.7-18.3 22.4-27.5 32zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9 3.7-12.9 8.3-26.2 13.5-39.5 4.1 8 8.4 16 13.1 24 4.7 8 9.5 15.8 14.4 23.4zM420.7 163c9.3 9.6 18.6 20.3 27.8 32-9-.4-18.2-.7-27.5-.7-9.4 0-18.7.2-27.8.7 9-11.7 18.3-22.4 27.5-32zm-74 58.9c-4.9 7.7-9.8 15.6-14.4 23.7-4.6 8-8.9 16-13 24-5.4-13.4-10-26.8-13.8-39.8 13.1-3.1 26.9-5.8 41.2-7.9zm-90.5 125.2c-35.4-15.1-58.3-34.9-58.3-50.6 0-15.7 22.9-35.6 58.3-50.6 8.6-3.7 18-7 27.7-10.1 5.7 19.6 13.2 40 22.5 60.9-9.2 20.8-16.6 41.1-22.2 60.6-9.9-3.1-19.3-6.5-28-10.2zM310 490c-13.6-7.8-19.5-37.5-14.9-75.7 1.1-9.4 2.9-19.3 5.1-29.4 19.6 4.8 41 8.5 63.5 10.9 13.5 18.5 27.5 35.3 41.6 50-32.6 30.3-63.2 46.9-84 46.9-4.5-.1-8.3-1-11.3-2.7zm237.2-76.2c4.7 38.2-1.1 67.9-14.6 75.8-3 1.8-6.9 2.6-11.5 2.6-20.7 0-51.4-16.5-84-46.6 14-14.7 28-31.4 41.3-49.9 22.6-2.4 44-6.1 63.6-11 2.3 10.1 4.1 19.8 5.2 29.1zm38.5-66.7c-8.6 3.7-18 7-27.7 10.1-5.7-19.6-13.2-40-22.5-60.9 9.2-20.8 16.6-41.1 22.2-60.6 9.9 3.1 19.3 6.5 28.1 10.2 35.4 15.1 58.3 34.9 58.3 50.6-.1 15.7-23 35.6-58.4 50.6zM320.8 78.4z" />
//     </SvgIcon>
//   )
// }

class Header extends Component {
  constructor(props) {
    super(props)

    this.state = {
      anchorElement: null,
      value: 0,
      groupsLoading: {},
    }
  }

  signOut = () => {
    jwtToken
      ? window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage('signout')
      : this.props.userSignOut()
  }

  handleHelpClickMobile = () => {
    if (
      jwtToken &&
      window.ReactNativeWebView &&
      window.ReactNativeWebView.postMessage
    ) {
      window.ReactNativeWebView.postMessage('https://vastreach.com/faq')
    }
  }

  handleGroupIconClick = event => {
    this.setState({ anchorElement: event.currentTarget })
  }

  handleGroupMenuClose = () => {
    this.setState({ anchorElement: null })
  }

  handleContactGroupChange = id => event => {
    const { addContactsToGroup, removeContactsFromGroup, selectedContacts } =
      this.props
    const checked = event?.target?.checked

    this.setState(
      { groupsLoading: { ...this.state.groupsLoading, [id]: true } },
      () => {
        return checked
          ? addContactsToGroup(selectedContacts, id).then(() =>
              this.setState({
                groupsLoading: { ...this.state.groupsLoading, [id]: false },
              }),
            )
          : removeContactsFromGroup(selectedContacts, id).then(() =>
              this.setState({
                groupsLoading: { ...this.state.groupsLoading, [id]: false },
              }),
            )
      },
    )
  }

  handleChange = (event, value) => {
    if (value === 0) {
      this.props.push('/email')
    } else {
      this.props.push('/sms')
    }
  }

  render() {
    const {
      classes,
      toggleDrawer,
      selectedContacts,
      deselectAllContacts,
      openCreateGroupFromSelectedDialog,
      groups,
      location,
      selectAllContacts,
      title,
      displayName,
      currentRoute,
    } = this.props

    const { anchorElement } = this.state

    const displayTitle = displayName || title || 'Vast Reach'

    const normalToolbar = (
      <Toolbar disableGutters>
        <div
          className="ignore-react-onclickoutside"
          onClick={() => {
            toggleDrawer()
          }}
        >
          <Tooltip title="Menu">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              className={classes.menuButton}
              disabled={this.props.drawerOpen}
            >
              <LogoMark style={{ width: 25, height: 25 }} />
            </IconButton>
          </Tooltip>
        </div>
        <div className={classes.titleContainer}>
          <Typography
            variant="h6"
            color="inherit"
            className={classes.title}
            noWrap
          >
            {displayTitle}
          </Typography>
          {!displayName && title && currentRoute?.helperText && (
            <div className={classes.helpTooltipContainer}>
              <HelpTooltip color="white">
                {currentRoute.helperText}
              </HelpTooltip>
            </div>
          )}
        </div>
        <div className={classes.actionButtons}>
          <HeaderVastGptButton />
          <HeaderAddButton location={location} push={this.props.push} />
        </div>
      </Toolbar>
    )

    const selectedContactsToolbar = (
      <Toolbar disableGutters>
        <IconButton
          color="secondary"
          aria-label="back"
          className={classes.menuButton}
          onClick={deselectAllContacts}
        >
          <ArrowBackIcon />
        </IconButton>
        <Typography
          variant="h6"
          color="secondary"
          noWrap
          className={classes.flex}
        >
          {`${Object.keys(selectedContacts).length} selected`}
        </Typography>
        <Button color="secondary" onClick={() => selectAllContacts()}>
          Select all
        </Button>
        <Tooltip title={language.header.labels.manageGroupsContacts}>
          <IconButton
            color="secondary"
            style={{ marginRight: '32px' }}
            onClick={event => this.handleGroupIconClick(event)}
          >
            <GroupIcon />
          </IconButton>
        </Tooltip>
        <Menu
          id="group-menu"
          anchorEl={anchorElement}
          open={Boolean(anchorElement)}
          onClose={this.handleGroupMenuClose}
          TransitionComponent={Fade}
        >
          <ListSubheader
            style={{ backgroundColor: '#fff', borderBottom: '1px solid #eee' }}
          >
            {language.header.manageGroups}
          </ListSubheader>
          {Object.keys(groups).map(id => (
            <MenuItem key={`contactGroup${id}onManageGroupMenu`}>
              {!this.state.groupsLoading[id] ? (
                <Checkbox
                  checked={isEqual(
                    pick(groups[id].memberIDs, Object.keys(selectedContacts)),
                    selectedContacts,
                  )}
                  onChange={this.handleContactGroupChange(id)}
                  value={id}
                />
              ) : (
                <CircularProgress style={{ margin: 4 }} />
              )}
              <ListItemText primary={`${groups[id].name}`} />
            </MenuItem>
          ))}
          <Divider />
          <MenuItem
            className={classes.menuItem}
            onClick={openCreateGroupFromSelectedDialog}
          >
            <GroupAddIcon />
            <ListItemText primary="Create group from selected" />
          </MenuItem>
        </Menu>
      </Toolbar>
    )

    return (
      <AppBar
        // style={jwtToken ? { display: 'none' } : null}
        position="fixed"
        className={
          Object.keys(selectedContacts).length
            ? classNames(classes.appBar, classes.colorOnContactSelection)
            : classNames(classes.appBar, classes.colorPrimary)
        }
      >
        {Object.keys(selectedContacts).length
          ? selectedContactsToolbar
          : normalToolbar}
      </AppBar>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withStyles(styles, { withTheme: true })(Header)),
)
